<div class="popover-icons absolute p-2 grid grid-cols-5">
	<div class="status" *ngFor="let icon of icons">
		<img
			class="w-5 h-5 cursor-pointer"
			(click)="selected(icon)"
			[src]="icon.url"
			[alt]="icon.name"
		/>
	</div>
</div>
